export default "__VITE_ASSET__DyivHVle__"